import { Box, Drawer as MuiDrawer, SxProps, Theme } from '@mui/material';
import { CandidateStatusDrawer } from 'services/candidate/components/CandidateStatusDrawer';
import { ConversationDetailsDrawer } from 'modules/conversations/components/ConversationDetailsDrawer';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { JobDescriptionHtmlDrawer } from 'modules/ats/components/JobDescriptionHtmlDrawer';
import { DrawerCloseButton } from './DrawerCloseButton';
import { InviteUserDrawer } from 'services/userOrganization/Components/InviteUserDrawer';
import { TeamPermissionsDrawer } from 'services/userOrganization/Components/TeamPermissionsDrawer';
import { WhatsAppSetupDrawer } from 'modules/onboarding/components/WhatsAppSetupDrawer';
import { UpdateApplicationStageDrawer } from 'modules/conversations/components';
import { CalendarBookingDetailsDrawer } from 'modules/calendar/components/CalendarBookingDetailsDrawer';
import { AnalysisRequirementsDrawer } from 'modules/analyse/components/AnalysisRequirementsDrawer';
import { CandidateReportDrawer } from 'modules/analyse/components/CandidateReportDrawer';
import { AnalysisRulesDrawer } from 'modules/analyse/components/AnalysisRulesDrawer';
import { AnalysisActionsDrawer } from 'modules/analyse/components/AnalysisActionsDrawer';
import { CampaignCreationJobDescriptionHtmlDrawer } from 'modules/campaigns/components/CampaignCreationJobDescriptionHtmlDrawer';
import { CandidateRankingGroupEditingDrawer } from 'modules/analyse/components/CandidateRankingGroupEditingDrawer';
import { SMSLearnMoreDrawer } from 'modules/campaigns/components/SMSLearnMoreDrawer';
import { WhatsAppLearnMoreDrawer } from 'modules/campaigns/components/WhatsAppLearnMoreDrawer';
import { RulesetsListDrawer } from 'modules/analyse/components/RulesetsListDrawer';
import { TemplateCreationDrawer } from 'modules/analyse-templates/components/TemplateCreationDrawer';
import { GlobalContextDrawer } from 'modules/organization/components/GlobalContextDrawer';

const container = {
  maxWidth: '80vw',
  padding: '30px 32px',
  gap: '32px',
  height: '100vh',
  overflowY: 'auto'
} satisfies SxProps<Theme>;

const conversationContainer = {
  ...container,
  padding: '30px'
} satisfies SxProps<Theme>;

const conversationCloseContainer: SxProps = {
  top: 33,
  right: 30
};

const conversationCloseButton: SxProps = {
  px: '8px',
  py: '6px'
};

/** @deprecated use DrawerV2 instead */
const CONTENT_COMPONENTS = {
  [DrawerComponentType.ConversationDetails]: ConversationDetailsDrawer,
  [DrawerComponentType.JobDescriptionHtml]: JobDescriptionHtmlDrawer,
  [DrawerComponentType.CampaignCreationJobDescriptionHtmlDrawer]:
    CampaignCreationJobDescriptionHtmlDrawer,
  [DrawerComponentType.CandidateReport]: CandidateReportDrawer,
  [DrawerComponentType.CandidateStatusDrawer]: CandidateStatusDrawer,
  [DrawerComponentType.InviteUserDrawer]: InviteUserDrawer,
  [DrawerComponentType.TeamPermissionsDrawer]: TeamPermissionsDrawer,
  [DrawerComponentType.WhatsAppSetup]: WhatsAppSetupDrawer,
  [DrawerComponentType.UpdateApplicationStage]: UpdateApplicationStageDrawer,
  [DrawerComponentType.CalendarBookingDetailsDrawer]:
    CalendarBookingDetailsDrawer,
  [DrawerComponentType.AnalysisRequirementsDrawer]: AnalysisRequirementsDrawer,
  [DrawerComponentType.AnalysisRulesDrawer]: AnalysisRulesDrawer,
  [DrawerComponentType.AnalysisActionsDrawer]: AnalysisActionsDrawer,
  [DrawerComponentType.CandidateRankingGroupEdit]:
    CandidateRankingGroupEditingDrawer,
  [DrawerComponentType.SMSLearnMoreDrawer]: SMSLearnMoreDrawer,
  [DrawerComponentType.WhatsAppLearnMoreDrawer]: WhatsAppLearnMoreDrawer,
  [DrawerComponentType.RulesetDrawer]: RulesetsListDrawer,
  [DrawerComponentType.TemplateCreationDrawer]: TemplateCreationDrawer,
  [DrawerComponentType.GlobalContextDrawer]: GlobalContextDrawer
};

/** @deprecated use DrawerV2 instead */
export const Drawer = () => {
  const { isOpen, closeDrawer, drawerContentType, drawerComponentProps } =
    useDrawer();

  const isConversationDrawer =
    drawerContentType === DrawerComponentType.ConversationDetails;

  const ContentComponent =
    drawerContentType && CONTENT_COMPONENTS[drawerContentType]
      ? CONTENT_COMPONENTS[drawerContentType]
      : null;

  return (
    <MuiDrawer
      anchor="right"
      open={isOpen}
      onClose={closeDrawer}
      ModalProps={{
        keepMounted: false
      }}
    >
      <Box sx={isConversationDrawer ? conversationContainer : container}>
        {!drawerComponentProps?.hideCloseIconButton && (
          <DrawerCloseButton
            containerSx={
              isConversationDrawer ? conversationCloseContainer : undefined
            }
            buttonSx={
              isConversationDrawer ? conversationCloseButton : undefined
            }
          />
        )}
        {ContentComponent && <ContentComponent {...drawerComponentProps} />}
      </Box>
    </MuiDrawer>
  );
};
